<!-- 查看课件 -->
<template>
  <div class="el-coursewareViewing">
    <el-row class="content_block mb20">
      <TitleInfo title="资源查看" :titleImg="ckkj"></TitleInfo>
      <el-row class="p20" style="min-height: 320px;overflow: auto;">
        <el-col :span="24">
          <el-row v-if="show.load" class="showBox tc" style="display: flex;justify-content:center;align-items:center;">
            <i class="el-icon-loading font30"></i>
          </el-row>
          <el-row v-show="show.PDFShow" class="showBox">
            <lookPdf v-if="!$isEmpty(show.PDFUrl)" :pdfUrl="show.PDFUrl"></lookPdf>
            <!-- <VuePdf v-if="show.PDFShow" :pdfUrl="show.PDFUrl"></VuePdf> -->
            <!-- <iframe id="iframe" :src='show.PDFUrl+"#toolbar=0"' width='100%' height='100%' frameborder='1'></iframe>
            <a class="qpclass" v-if="!PdfFullScreenShow" @click="fullScreen()">全屏</a>
            <a class="qpclass" v-else @click="quitFullScreen()">退出</a> -->
          </el-row>
          <!-- 视频查看 -->
          <el-row v-show="show.mp4Show" class="showBox">
            <video @timeupdate="onTimeupdate" id="myVideo" style="width: 100%;height: 100%;" class="video-js vjs-default-skin vjs-big-play-centered" x-webkit-airplay="allow" poster="" webkit-playsinline playsinline x5-video-player-type="h5" x5-video-player-fullscreen="true" preload="auto">
                <source type="application/x-mpegURL">
            </video>
          </el-row>
          <el-row v-show="show.fileShow" class="showBox">
            <iframe id="InformationURL" :src='show.fileUrl' width='100%' height='100%' frameborder='1'></iframe>
          </el-row>
          <el-row v-show="show.imgShow" class="showBox" style="padding: 20px;overflow: auto;">
            <h2 style="text-align: center;">{{show.imgTitle}}</h2>
            <el-row v-html="show.imgUrl"></el-row>
          </el-row>
        </el-col>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import TitleInfo from "@/components/TitleInfo";	//页面头部
import lookPdf from "@/components/lookPdf"; //引入PDF查看器
import { log } from "video.js";
export default {
  name: "CoursewareViewing",
  components: {
  	TitleInfo,
    lookPdf
  },
  data() {
    return {
      ckkj:require("../../images/course/ckkj@2x.png"),
      infoDate:this.$route.query.item,
      player:null,
      show:{
        load:true,
        PDFShow:false,
        PDFUrl:"",
        mp4Show:false,
        mp4Url:"",
        fileShow:false,
        fileUrl:"",
        imgShow:false,
        imgUrl:"",
        imgTitle:"",
        httpShow:false,
        httpUrl:"",
      },
    };
  },
  created() {
    this.infoDate = this.$ls.get(this.$getKeyInfo("TCoursewareViewingInfo"));
    this.getInfo();
  },
  mounted() {
    this.initVideo();
  },
  methods: {
    getInfo(){ //获取列表
      this.show.load = false;
      this.handleNodeClick(this.infoDate);
    },
    handleNodeClick(data) { //1	视频 2	PPT 3	PDF 4	链接 5	图文
      this.show.mp4Show = data.resourcesInfoType == 1?true:false;
      this.show.fileShow = data.resourcesInfoType == 2?true:false;
      this.show.PDFShow = data.resourcesInfoType == 3?true:false;
      this.show.imgShow = data.resourcesInfoType == 5?true:false;
      if(data.resourcesInfoType == 1){
        this.player.src({src:this.$isHttp(data.resourcesInfoContent),type:data.resourcesInfoContent.indexOf(".mp4")>=0?'video/mp4':'video/webm'});
        this.player.play(); //播放
      }else if(data.resourcesInfoType == 2){
        if(data.resourcesInfoFiles.indexOf(".pdf") >= 0 || data.resourcesInfoFiles.indexOf(".PDF") >= 0){
          this.show.PDFUrl = this.$isHttp(data.resourcesInfoFiles);
          this.show.fileShow = false;
          this.show.PDFShow = true;
        }else{
          this.show.fileUrl = this.$viewUrl + this.$isHttp(data.resourcesInfoFiles);
          this.show.fileShow = true;
          this.show.PDFShow = false;
        }
      }else if(data.resourcesInfoType == 3){
        this.show.PDFUrl = this.$isHttp(data.resourcesInfoContent);
      }else if(data.resourcesInfoType == 5){
        this.show.imgUrl = data.resourcesInfoContent;
        this.show.imgTitle = data.resourcesInfoName;
      }
    },
    initVideo() {
      let this_ = this;
      this.player = this.$video(myVideo, {
          //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
          controls: true,
          //自动播放属性,muted:静音播放
          autoplay: false,
          //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
          preload: "auto",
          autoDisable: true,
          //设置视频播放器的显示宽度（以像素为单位）
          // playbackRates: [0.5, 1, 1.5, 2],
          sources:[ // 视频源
            {
              src: this.mp4Url,//"../../../static/jl.mp4"
              poster: ''
            }]
      }, function onPlayerReady() {
        //this_.player.currentTime(5); //指定视频的开始播放位置
      });
    },
    onTimeupdate(e){ //判断是否播放完成

    }
  }
};
</script>
 <style  lang="less">
  .el-coursewareViewing{
    padding: 20px 20px 0;
    .content_block{
      background-color: #ffffff;
    }
    .showBox{
      width: calc(100% - 20px);height: calc(100vh - 220px);border: 1px solid #D3D3D3;
      img{
        max-width: 100%;
      }
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/Teacher/CoursewareViewing.vue